import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * PublicRoute - Only accessible when NOT logged in.
 * If the user already has an active session, they get redirected
 * to their vendor dashboard automatically.
 */
export default function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  // Wait for auth check before deciding — prevents flash of login page
  if (loading) return null;

  // Session exists → redirect to their dashboard
  if (user) {
    return <Navigate to={`/vendor/${user.id}`} replace />;
  }

  // No session → render the page normally (login, signup, etc.)
  return children;
}
